import React, { useEffect, useState } from "react";


export default function SoonMatches() {
  const [matches, setMatches] = useState([]);

  const handleChange = (e) => {
    const value = e.target.value;

    const params = new URLSearchParams(window.location.search);

    params.set("match", value);

    window.location.search = params.toString();
  };


  useEffect(() => {
    const getData = async () => {
      const data = await fetchMatchData();

      setMatches(data);
    };
    getData();
  }, []);

  return (
    <div>
      <label>Matchs à vomir</label>
      {matches.length === 0 ? (
        <label>  Chargement...</label>
      ) : (
    <select onChange={handleChange}>
        <option selected disabled>--Choisir un match --</option>
    {matches.map((match) => (
        <option value={match.idMatch}> {match.nameEvent}: {match.nameTeam1} vs {match.nameTeam2} (match {match.numeroMatch+1})</option>
    ))
    }
    </select>
    )}
    </div>
  );
}


async function fetchMatchData() {
  try {
    const params = new URLSearchParams(window.location.search);
    const apiKey = params.get("api_key") || "";

    const response = await fetch(
      `https://grubs.epic-company.world/getSoonMatches?api_key=${apiKey}`
    );
    if (!response.ok) throw new Error("Erreur HTTP " + response.status);

    const data = await response.json();
    const matchesArray = Object.values(data);
    console.log("match array",matchesArray) 
    return matchesArray[0];
  } catch (error) {
    console.error("Erreur lors du fetch :", error);
    return [];
  }
}
